<template>
  <div>
    <div id="about" :style="{ backgroundImage: 'url(' + backImg + ')' }">
      <div class="beijin" style="backgroundimage:url('./../assets/beijin.jpg);">
        <div class="moban"></div>
        <div class="sconed_select">
          <div class="center_box">
            <div
              :class="activeIndex == index ? 'select_item1' : 'select_item'"
              v-for="(item, index) in selectArr"
              :key="index"
              @click="select(index)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="child_box">
          <EnterTianyi
            class="child_transition"
            v-if="activeIndex == 0"
          ></EnterTianyi>
          <DevelopmentHistory
            class="child_transition"
            v-if="activeIndex == 1"
          ></DevelopmentHistory>
          <Honor class="child_transition" v-if="activeIndex == 2"></Honor>
          <Recruit class="child_transition" v-if="activeIndex == 3"></Recruit>
          <ContactUs
            class="child_transition"
            v-if="activeIndex == 4"
          ></ContactUs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EnterTianyi from "../../components/AboutPage/EnterTianyi";
import DevelopmentHistory from "../../components/AboutPage/DevelopmentHistory";
import Honor from "../../components/AboutPage/Honor";
import Recruit from "../../components/AboutPage/Recruit";
import ContactUs from "../../components/AboutPage/ContactUs";
export default {
  name: "",
  props: {},
  components: {
    EnterTianyi,
    DevelopmentHistory,
    Honor,
    Recruit,
    ContactUs,
  },
  data() {
    return {
      activeIndex: this.$route.query.activeIndex
        ? Number(this.$route.query.activeIndex)
        : 0,
      selectArr: [
        {
          title: "走进天亿",
        },
        {
          title: "发展历程",
        },
        {
          title: "资质荣誉",
        },
        {
          title: "招贤纳士",
        },
        {
          title: "联系我们",
        },
      ],
      backImg: "",
    };
  },
  methods: {
    select(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          sessionStorage.setItem("aboutActive", 9);
          break;
        case 1:
          sessionStorage.setItem("aboutActive", 5);
          break;
        case 2:
          sessionStorage.setItem("aboutActive", 6);
          break;
        case 3:
          sessionStorage.setItem("aboutActive", 7);
          break;
        case 4:
          sessionStorage.setItem("aboutActive", 8);
      }
      this.$router.push({
        path: "/about",
        query: {
          activeIndex: index,
        },
      });
    },
  },
  mounted() {
    var i = Number(sessionStorage.getItem("aboutActive"));
    if (i) {
      if (this.baclgroundInfo.length === 0) {
        setTimeout(() => {
          var obj = this.baclgroundInfo;
          this.backImg = obj[i].image;
        }, 500);
      } else {
        var obj = this.baclgroundInfo;
        this.backImg = obj[i].image;
      }
    } else {
      if (this.baclgroundInfo.length === 0) {
        setTimeout(() => {
          var obj = this.baclgroundInfo;
          this.backImg = obj[9].image;
        }, 500);
      } else {
        var obj = this.baclgroundInfo;
        this.backImg = obj[9].image;
      }
    }
  },
  watch: {
    activeIndex(val) {
      if (val == 0) {
        this.backImg = this.baclgroundInfo[9].image;
      }
      if (val == 1) {
        this.backImg = this.baclgroundInfo[5].image;
      }
      if (val == 2) {
        this.backImg = this.baclgroundInfo[6].image;
      }
      if (val == 3) {
        this.backImg = this.baclgroundInfo[7].image;
      }
      if (val == 4) {
        this.backImg = this.baclgroundInfo[8].image;
      }
    },
  },
  computed: {
    baclgroundInfo() {
      return this.$store.state.baclgroundInfo;
    },
  },
};
</script>

<style scoped lang='scss'>
#about {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  background-size: cover;
  position: relative;
  background-repeat: no-repeat;
  .beijin {
    width: 100%;
    height: 100%;
    position: relative;
    .moban {
 position: absolute;
    right: 50%;
    width: 303px;
    height: 100%;
    z-index: 3;
    top: 0px;
    background-image: linear-gradient(to left, #1a1a1a, rgba(26, 26, 26, 0.6), rgba(0, 0, 0, 0));
    }
  }
  .beijin::after {
    background-image: url(../../assets/indexImg/beijin.jpg);
    background-repeat: no-repeat;
    background-size: 50% 100%;
    position: absolute;
    opacity: 0.1;
    top: 0px;
    content: "";
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2;
  }
  .sconed_select {
    z-index: 3;
    width: 100%;
    // height: 40px;
    height: 4vh;
    position: absolute;
    // top: 150px;
    top: 15vh;
    .center_box {
      width: 1322px;
                @media only screen and (min-width: 1900px) {
      width: 1500px;
    }
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .select_item {
        width: 200px;
        height: 100%;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // line-height: 40px;
        line-height: 4vh;
        color: rgba(255, 255, 255, 0.5);
        text-align: center;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
        transition: all 0.5s;
        cursor: url("../../assets/cursor.png"), none;
      }
      .select_item:hover {
        color: #0fffff;
        border-bottom: 1px solid #0fffff;
        transition: all 0.5s;
      }
      .select_item1 {
        width: 200px;
        height: 100%;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // line-height: 40px;
        line-height: 4vh;
        color: #0fffff;
        text-align: center;
        border-bottom: 1px solid #0fffff;
        transition: all 0.5s;
      }
    }
  }
  .child_box {
    z-index: 3;
    width: 100%;
    position: absolute;
    // top: 190px;
    top: 19vh;
    .child_transition {
      animation: myChild 1s linear;
    }
    @keyframes myChild {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
}
#about::after {
    background-repeat: no-repeat;
    background-size: 50% 100%;
    position: absolute;
    top: 0px;
    width: 50%;
    content: "";
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 1;
      background: #1a1a1a;
  }
</style>